export default {
  SIGNUP: 'signup',
  VERIFY: 'verify',
  PDS: 'pds',
  SETUP: 'setup',
  VEDA: 'veda',
  TMD: 'tmd',
  APPLICATION_REVIEW: 'application_review',
  DEPOSIT: 'deposit',
  INVEST: 'invest',
  DONE: 'done',
};
